import { render, staticRenderFns } from "./MainSidebarView.vue?vue&type=template&id=427f78de&"
import script from "./MainSidebarView.vue?vue&type=script&lang=js&"
export * from "./MainSidebarView.vue?vue&type=script&lang=js&"
import style0 from "./MainSidebarView.vue?vue&type=style&index=0&id=427f78de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports